import React from "react";
import { Textarea } from "@chakra-ui/react";
import { Controller } from "react-hook-form";
import FieldFrame from "./FieldFrame";

const TextAreaField = ({ field, control, disabled, error, required }) => (
  <Controller
    control={control}
    name={field.code}
    render={({ field: input }) => (
      <FieldFrame field={field} error={error} isRequired={required}>
        <Textarea
          {...input}
          value={input.value ?? ""}
          minH="110px"
          placeholder={field.placeholder}
          isDisabled={disabled}
        />
      </FieldFrame>
    )}
  />
);

export default TextAreaField;
